import {
  CAT_IN_A_FLAT_DOMAINS,
  CatInAFlatDomain,
} from '@rover/constants/src/platform/domains.constants';
import { matchesDomain } from '@rover/utilities/getRoverBrand/domain-utils';
import type { CountryUrlPrefix } from '@rover/utilities/roverGeo.constants';

export const COUNTRY_URL_PREFIX_BY_CAT_IN_A_FLAT_DOMAIN: Record<
  CatInAFlatDomain,
  CountryUrlPrefix | undefined
> = {
  [CatInAFlatDomain.Local]: undefined,
  [CatInAFlatDomain.Dev]: undefined,
  [CatInAFlatDomain.Com]: 'us',
  [CatInAFlatDomain.CoUk]: 'uk',
  [CatInAFlatDomain.Ca]: 'ca',
  [CatInAFlatDomain.De]: 'de',
  [CatInAFlatDomain.Es]: 'es',
  [CatInAFlatDomain.Fr]: 'fr',
  [CatInAFlatDomain.Ie]: 'ie',
  [CatInAFlatDomain.Be]: 'be',
  [CatInAFlatDomain.At]: 'at',
  [CatInAFlatDomain.Nl]: 'nl',
  [CatInAFlatDomain.Ch]: 'ch',
};

const getCountryUrlPrefixFromHostname = (hostname: string): CountryUrlPrefix | undefined => {
  const domain = CAT_IN_A_FLAT_DOMAINS.find((candidate) => matchesDomain(hostname, candidate));
  return domain && COUNTRY_URL_PREFIX_BY_CAT_IN_A_FLAT_DOMAIN[domain];
};

export default getCountryUrlPrefixFromHostname;
